import React, { Component } from 'react';
import Summary from '../components/Summary';
import MontemarAdelantosSummary from '../components/MontemarAdelantosSummary';
import ContractsContainer from '../containers/ContractsContainer';
import { Col, Row } from 'react-bootstrap';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import FlowProgressBar from "./FlowProgressBar";
import LeadInfo from './LeadInfo.js';
import {FormattedHTMLMessage} from 'react-intl';

require(`../assets/${process.env.PAGE}/css/components/CheckOut.css`);

class CheckOut extends Component {

    render() {
        const { clientName } = this.props;
        let summaryComponent;

        switch(process.env.PAGE){
            case 'montemar-adelantos':
                summaryComponent = (<MontemarAdelantosSummary/>);
                break;
            default:
                summaryComponent = (<Summary/>)
        }

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="col-md-12 col-lg-12 text-center checkout-header" >
                        <div className="header-img" >
                            <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo_blanco_montemar.png`)} />
                        </div>
                        <div className="header-message">
                            <FormattedHTMLMessage id="app.step_checkout" description="Checkout info" values={{ nameClient: clientName, }} />
                        </div>
                        <div className='show-mobile-progress-bar'><FlowProgressBar /></div>
                    </div>
                </div>
                <Row className="checkout-form flex-lg-column">
                    <Col className="terms-container " xs={12} md={8} lg={12}>
                        {summaryComponent}
                    </Col>

                    <Col xs={12} md={4} lg={12}>
                        <Row>
                            <Col className="terms-container" xs={12} md={12}>
                                <div className='show-desktop-progress-bar'><FlowProgressBar /></div>
                                <ContractsContainer />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Section>
        );
    }
}

CheckOut = TopScrolleable(CheckOut);

CheckOut = LeadInfo(CheckOut);

CheckOut = withAuthControl(CheckOut);
export default CheckOut;



/** WEBPACK FOOTER **
 ** ./src/components/CheckOut.js
 **/